import {getPublishedCustomViews} from '../helper'
const publishedCustomViewsStore = {
  state: {
    publishedCustomViews: []
  },
  getters: {
    publishedCustomViews(state) {
      return state.publishedCustomViews
    },
  },
  actions: {
    async refreshPublishedCustomViews (context) {
      let result = await getPublishedCustomViews()
      context.commit('setPublishedCustomViews', result.views.map(x=>x.json))
    },
  },

  mutations: {
    setPublishedCustomViews (state, publishedCustomViews) {
      state.publishedCustomViews = publishedCustomViews
    }
  }
}

export default publishedCustomViewsStore
